import { i18n, type TranslationInterpolations } from ".";
import { getNestedKeyValue, type NestedKey } from "../nestedKey";

export const t = (key: NestedKey<typeof i18n.value.translations>, interpolation?: TranslationInterpolations) => {
    if (!i18n.value) {
        console.warn("i18n instance is not initialized");
        return "";
    }

    let value = getNestedKeyValue(i18n.value.translations, key);
    if (!value) {
        console.warn(`No translation for key "${key}". Are you using pp, customer or admin on main?`);
        return "";
    }
    if (interpolation && typeof value.replaceAll === "function") {
        if (Array.isArray(interpolation)) {
            interpolation.forEach((item, index) => {
                value = value.replaceAll(`:${index}`, item.toString());
            });
        } else {
            for (const [k, v] of Object.entries(interpolation)) {
                value = value.replaceAll(`:${k}`, v.toString());
            }
        }
    }

    return value;
};
